export const PurchaseOrderImage = () => {
  return (
    <svg
      width="206"
      height="153"
      viewBox="0 0 206 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_297_57359)">
        <path
          d="M128.448 98.3942H78.6821C76.5601 98.3942 74.8423 96.6764 74.8423 94.5545V26.2973C74.8423 24.1753 76.5601 22.4575 78.6821 22.4575H128.448C130.57 22.4575 132.287 24.1753 132.287 26.2973V94.5545C132.287 96.6764 130.57 98.3942 128.448 98.3942Z"
          fill="url(#paint0_linear_297_57359)"
        />
      </g>
      <path
        d="M110.031 79.9787H97.0967C95.6567 79.9787 94.4946 78.8166 94.4946 77.3767C94.4946 75.9367 95.6567 74.7747 97.0967 74.7747H110.031C111.471 74.7747 112.633 75.9367 112.633 77.3767C112.633 78.8166 111.471 79.9787 110.031 79.9787Z"
        fill="#D5DDEA"
      />
      <path
        d="M115.967 85.6116H91.1342C90.3763 85.6116 89.77 85.0053 89.77 84.2474C89.77 83.4896 90.3763 82.8833 91.1342 82.8833H115.967C116.725 82.8833 117.331 83.4896 117.331 84.2474C117.331 84.98 116.725 85.6116 115.967 85.6116Z"
        fill="#D5DDEA"
      />
      <path
        d="M120.54 49.5382C120.54 54.6411 118.292 59.2135 114.73 62.3207C111.749 64.9227 107.834 66.4889 103.564 66.4889C99.2951 66.4889 95.3795 64.9227 92.3986 62.2954C88.8367 59.1882 86.5884 54.6158 86.5884 49.5129C86.5884 40.1407 94.1922 32.5369 103.564 32.5369C112.937 32.5369 120.54 40.166 120.54 49.5382Z"
        fill="#7647EE"
      />
      <path
        d="M117.205 38.9199C117.869 38.9199 118.407 38.3815 118.407 37.7173C118.407 37.0531 117.869 36.5146 117.205 36.5146C116.541 36.5146 116.003 37.0531 116.003 37.7173C116.003 38.3815 116.541 38.9199 117.205 38.9199Z"
        fill="#EAEEF9"
      />
      <path
        d="M85.2881 45.4235C85.7246 45.4235 86.0785 45.0692 86.0785 44.6323C86.0785 44.1953 85.7246 43.8411 85.2881 43.8411C84.8515 43.8411 84.4976 44.1953 84.4976 44.6323C84.4976 45.0692 84.8515 45.4235 85.2881 45.4235Z"
        fill="#EAEEF9"
      />
      <path
        d="M88.9218 59.6478C89.3584 59.6478 89.7123 59.2936 89.7123 58.8566C89.7123 58.4197 89.3584 58.0654 88.9218 58.0654C88.4853 58.0654 88.1313 58.4197 88.1313 58.8566C88.1313 59.2936 88.4853 59.6478 88.9218 59.6478Z"
        fill="#EAEEF9"
      />
      <path
        d="M93.1475 59.6478L104.24 56.1719V41.9209L93.1475 45.37V59.6478Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M115.333 59.6478L104.24 56.1719V41.9209L115.333 45.37V59.6478Z"
        fill="#6D7C9A"
      />
      <path
        d="M93.1475 59.6478L104.24 56.1719V41.9209L93.1475 45.37V59.6478Z"
        fill="url(#paint1_linear_297_57359)"
      />
      <path
        d="M115.333 59.6478L104.24 56.1719V41.9209L115.333 45.37V59.6478Z"
        fill="url(#paint2_linear_297_57359)"
      />
      <path
        d="M104.24 63.1505L93.1475 59.6746V45.4236L104.24 48.8994V63.1505Z"
        fill="#EDF1F9"
      />
      <path
        d="M104.24 63.1505L115.333 59.6746V45.4236L104.24 48.8994V63.1505Z"
        fill="#DAE1ED"
      />
      <path
        opacity="0.09"
        d="M101.727 60.6372L93.1475 59.6746V45.4236L104.24 48.8994L101.727 60.6372Z"
        fill="url(#paint3_linear_297_57359)"
      />
      <path
        opacity="0.2"
        d="M106.754 58.1238L115.333 59.6746V45.4236L104.24 48.8994L106.754 58.1238Z"
        fill="url(#paint4_linear_297_57359)"
      />
      <path
        d="M104.24 41.921L99.0247 38.0173L87.7466 41.814L93.1474 45.3701L104.24 41.921Z"
        fill="#DAE1ED"
      />
      <path
        d="M104.24 41.921L109.456 38.0173L120.734 41.814L115.333 45.3701L104.24 41.921Z"
        fill="#DAE1ED"
      />
      <path
        d="M93.1474 45.4236L104.24 48.8994L98.707 52.4288L87.7466 48.7925L93.1474 45.4236Z"
        fill="#EFF4FD"
      />
      <path
        d="M115.333 45.4236L104.24 48.8994L109.773 52.4288L120.734 48.7925L115.333 45.4236Z"
        fill="#EDF1F9"
      />
      <path
        d="M107.335 28.2395C108.889 32.457 109.353 33.3941 109.505 37.5498C109.446 38.4984 109.41 39.53 108.963 40.3606C108.365 41.6312 106.904 42.5112 105.524 42.5254C104.102 42.5508 102.708 41.6802 102.081 40.3378C101.64 39.523 101.654 38.4086 102.259 37.6689C102.917 36.9595 104.075 36.7826 104.908 37.2259C105.825 37.6468 106.372 38.5221 106.574 39.4453C106.777 40.3684 106.688 41.3696 106.441 42.28C105.924 44.494 105.495 44.6011 104.227 48.3497"
        stroke="#ABB5CC"
        strokeWidth="0.628329"
        strokeMiterlimit="10"
        strokeDasharray="1.26 1.26"
      />
      <path
        d="M109.226 26.0072C109.223 26.6273 108.646 27.0071 107.914 26.8091C107.143 26.6777 106.598 26.5423 106.563 25.9888C106.581 25.4212 107.2 25.199 107.925 24.9486C108.794 24.6032 109.177 25.4012 109.226 26.0072Z"
        fill="#DAE2EB"
      />
      <path
        d="M104.247 27.9036C104.638 28.3056 105.461 28.4228 105.862 27.8088C106.302 27.128 106.679 26.6332 106.274 26.1786C105.884 25.7766 105.504 26.0473 104.634 26.3926C103.938 26.7481 103.79 27.4632 104.247 27.9036Z"
        fill="#DAE2EB"
      />
      <path
        d="M106.049 25.3384C106.405 25.1869 106.83 25.2981 107.02 25.5849C107.101 25.6758 107.196 25.8193 107.224 25.9243C107.527 26.6313 107.432 27.3323 107.023 27.4979C106.577 27.7302 105.961 27.3322 105.725 26.6635C105.669 26.4534 105.641 26.3484 105.599 26.1908C105.553 25.809 105.694 25.4899 106.049 25.3384C106.102 25.3243 106.049 25.3384 106.049 25.3384Z"
        fill="#989FB0"
      />
      <path
        d="M89.7124 36.7198H89.0244V36.0317H88.4346V36.7198H87.7466V37.3292H88.4346V38.0172H89.0244V37.3292H89.7124V36.7198Z"
        fill="url(#paint5_linear_297_57359)"
      />
      <path
        d="M91.2236 53.9822H90.5356V53.2942H89.9458V53.9822H89.2578V54.5916H89.9458V55.2797H90.5356V54.5916H91.2236V53.9822Z"
        fill="url(#paint6_linear_297_57359)"
      />
      <path
        d="M121.301 54.0213L120.459 53.5962L120.884 52.7544L120.163 52.3901L119.738 53.2319L118.896 52.8069L118.519 53.5525L119.361 53.9775L118.936 54.8194L119.658 55.1837L120.083 54.3418L120.925 54.7669L121.301 54.0213Z"
        fill="url(#paint7_linear_297_57359)"
      />
      <g filter="url(#filter1_d_297_57359)">
        <path
          d="M60.8462 86.6479H28.8393C26.7173 86.6479 24.9995 84.9301 24.9995 82.8081V38.0439C24.9995 35.9219 26.7173 34.2041 28.8393 34.2041H60.8462C62.9682 34.2041 64.686 35.9219 64.686 38.0439V82.8333C64.686 84.9553 62.9682 86.6479 60.8462 86.6479Z"
          fill="url(#paint8_linear_297_57359)"
        />
      </g>
      <path
        d="M49.3018 73.9411H40.3586C39.3734 73.9411 38.5649 73.1327 38.5649 72.1475C38.5649 71.1622 39.3734 70.3538 40.3586 70.3538H49.3018C50.2871 70.3538 51.0955 71.1622 51.0955 72.1475C51.0955 73.1327 50.2871 73.9411 49.3018 73.9411Z"
        fill="#D5DDEA"
      />
      <path
        d="M53.4194 77.8308H36.2663C35.7357 77.8308 35.3315 77.4014 35.3315 76.8961C35.3315 76.3656 35.761 75.9614 36.2663 75.9614H53.4194C53.9499 75.9614 54.3541 76.3909 54.3541 76.8961C54.3541 77.4014 53.9247 77.8308 53.4194 77.8308Z"
        fill="#D5DDEA"
      />
      <path
        d="M56.5524 52.8983C56.5524 56.435 54.9861 59.5928 52.5357 61.7401C50.4641 63.5337 47.7863 64.62 44.8306 64.62C41.8749 64.62 39.1719 63.5337 37.1256 61.7401C34.6752 59.5928 33.1089 56.435 33.1089 52.8983C33.1089 46.4311 38.3635 41.1765 44.8306 41.1765C51.2978 41.1765 56.5524 46.4311 56.5524 52.8983Z"
        fill="#F7AD3C"
      />
      <path
        d="M52.5585 46.4818C52.9962 46.4818 53.3509 46.1267 53.3509 45.6886C53.3509 45.2506 52.9962 44.8955 52.5585 44.8955C52.1209 44.8955 51.7661 45.2506 51.7661 45.6886C51.7661 46.1267 52.1209 46.4818 52.5585 46.4818Z"
        fill="#EAEEF9"
      />
      <path
        d="M31.5091 50.7709C31.797 50.7709 32.0304 50.5373 32.0304 50.2491C32.0304 49.9609 31.797 49.7273 31.5091 49.7273C31.2212 49.7273 30.9878 49.9609 30.9878 50.2491C30.9878 50.5373 31.2212 50.7709 31.5091 50.7709Z"
        fill="#EAEEF9"
      />
      <path
        d="M33.9056 60.1517C34.1935 60.1517 34.4269 59.9181 34.4269 59.6299C34.4269 59.3418 34.1935 59.1082 33.9056 59.1082C33.6177 59.1082 33.3843 59.3418 33.3843 59.6299C33.3843 59.9181 33.6177 60.1517 33.9056 60.1517Z"
        fill="#EAEEF9"
      />
      <path
        d="M36.6924 60.1517L44.0081 57.8594V48.4609L36.6924 50.7356V60.1517Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M51.3235 60.1517L44.0078 57.8594V48.4609L51.3235 50.7356V60.1517Z"
        fill="#6D7C9A"
      />
      <path
        d="M36.6924 60.1517L44.0081 57.8594V48.4609L36.6924 50.7356V60.1517Z"
        fill="url(#paint9_linear_297_57359)"
      />
      <path
        d="M51.3237 60.1517L44.0081 57.8594V48.4609L51.3237 50.7356V60.1517Z"
        fill="url(#paint10_linear_297_57359)"
      />
      <path
        d="M44.0081 62.4616L36.6924 60.1692V50.7708L44.0081 53.0631V62.4616Z"
        fill="#EDF1F9"
      />
      <path
        d="M44.0078 62.4616L51.3235 60.1692V50.7708L44.0078 53.0631V62.4616Z"
        fill="#DAE1ED"
      />
      <path
        opacity="0.09"
        d="M42.3505 60.804L36.6924 60.1692V50.7708L44.0081 53.0631L42.3505 60.804Z"
        fill="url(#paint11_linear_297_57359)"
      />
      <path
        opacity="0.2"
        d="M45.6653 59.1465L51.3235 60.1692V50.7708L44.0078 53.0631L45.6653 59.1465Z"
        fill="url(#paint12_linear_297_57359)"
      />
      <path
        d="M44.0078 48.4609L40.5683 45.8865L33.1304 48.3904L36.6922 50.7356L44.0078 48.4609Z"
        fill="#DAE1ED"
      />
      <path
        d="M44.0078 48.4609L47.4474 45.8865L54.8853 48.3904L51.3235 50.7356L44.0078 48.4609Z"
        fill="#DAE1ED"
      />
      <path
        d="M36.6922 50.7708L44.0078 53.0631L40.3587 55.3907L33.1304 52.9925L36.6922 50.7708Z"
        fill="#EFF4FD"
      />
      <path
        d="M51.3235 50.7708L44.0078 53.0631L47.6569 55.3907L54.8853 52.9925L51.3235 50.7708Z"
        fill="#EDF1F9"
      />
      <path
        d="M46.0492 39.438C47.0741 42.2195 47.3796 42.8375 47.4798 45.5782C47.4413 46.2038 47.4174 46.884 47.1224 47.4318C46.7285 48.2698 45.7651 48.8501 44.8548 48.8595C43.9171 48.8763 42.9978 48.3021 42.584 47.4168C42.2929 46.8795 42.3021 46.1445 42.7015 45.6567C43.1356 45.1888 43.8993 45.0722 44.4487 45.3645C45.0531 45.6421 45.4138 46.2194 45.5474 46.8282C45.681 47.437 45.6223 48.0973 45.4592 48.6977C45.1181 50.1578 44.8356 50.2285 43.9991 52.7006"
        stroke="#ABB5CC"
        strokeWidth="0.41438"
        strokeMiterlimit="10"
        strokeDasharray="0.83 0.83"
      />
      <path
        d="M47.2962 37.9658C47.2939 38.3747 46.9133 38.6252 46.4306 38.4946C45.9224 38.408 45.5627 38.3187 45.5396 37.9536C45.5512 37.5793 45.9597 37.4328 46.4377 37.2676C47.0109 37.0399 47.2638 37.5661 47.2962 37.9658Z"
        fill="#DAE2EB"
      />
      <path
        d="M44.0125 39.2164C44.2701 39.4815 44.8131 39.5588 45.0777 39.1538C45.3678 38.7049 45.6162 38.3785 45.3493 38.0787C45.0918 37.8136 44.8412 37.9921 44.2679 38.2199C43.8084 38.4543 43.7109 38.9259 44.0125 39.2164Z"
        fill="#DAE2EB"
      />
      <path
        d="M45.2009 37.5248C45.4353 37.4249 45.716 37.4982 45.8413 37.6873C45.8947 37.7473 45.9573 37.8419 45.9759 37.9112C46.1754 38.3775 46.1127 38.8397 45.8435 38.949C45.5487 39.1021 45.1427 38.8397 44.9873 38.3987C44.9501 38.2601 44.9316 38.1909 44.9038 38.0869C44.8736 37.8352 44.9665 37.6247 45.2009 37.5248C45.2357 37.5155 45.2009 37.5248 45.2009 37.5248Z"
        fill="#989FB0"
      />
      <path
        d="M34.4268 45.0307H33.9731V44.5769H33.5841V45.0307H33.1304V45.4326H33.5841V45.8863H33.9731V45.4326H34.4268V45.0307Z"
        fill="url(#paint13_linear_297_57359)"
      />
      <path
        d="M35.4234 56.4152H34.9696V55.9614H34.5807V56.4152H34.127V56.8171H34.5807V57.2708H34.9696V56.8171H35.4234V56.4152Z"
        fill="url(#paint14_linear_297_57359)"
      />
      <path
        d="M55.2595 56.441L54.7044 56.1607L54.9847 55.6055L54.5088 55.3653L54.2285 55.9204L53.6733 55.6401L53.425 56.1319L53.9802 56.4122L53.6999 56.9673L54.1758 57.2076L54.4561 56.6524L55.0113 56.9327L55.2595 56.441Z"
        fill="url(#paint15_linear_297_57359)"
      />
      <g filter="url(#filter2_d_297_57359)">
        <path
          d="M177.531 86.6479H145.524C143.402 86.6479 141.684 84.9301 141.684 82.8081V38.0439C141.684 35.9219 143.402 34.2041 145.524 34.2041H177.531C179.653 34.2041 181.371 35.9219 181.371 38.0439V82.8333C181.371 84.9553 179.653 86.6479 177.531 86.6479Z"
          fill="url(#paint16_linear_297_57359)"
        />
      </g>
      <path
        d="M165.985 73.9411H157.042C156.057 73.9411 155.249 73.1327 155.249 72.1475C155.249 71.1622 156.057 70.3538 157.042 70.3538H165.985C166.971 70.3538 167.779 71.1622 167.779 72.1475C167.804 73.1327 166.996 73.9411 165.985 73.9411Z"
        fill="#D5DDEA"
      />
      <path
        d="M170.103 77.8308H152.95C152.419 77.8308 152.015 77.4014 152.015 76.8961C152.015 76.3656 152.445 75.9614 152.95 75.9614H170.103C170.634 75.9614 171.038 76.3909 171.038 76.8961C171.038 77.4014 170.634 77.8308 170.103 77.8308Z"
        fill="#D5DDEA"
      />
      <path
        d="M173.262 52.8983C173.262 56.435 171.696 59.5928 169.246 61.7401C167.174 63.5337 164.496 64.62 161.541 64.62C158.585 64.62 155.882 63.5337 153.836 61.7401C151.385 59.5928 149.819 56.435 149.819 52.8983C149.819 46.4311 155.073 41.1765 161.541 41.1765C168.008 41.1765 173.262 46.4311 173.262 52.8983Z"
        fill="#19AE57"
      />
      <path
        d="M170.724 46.4818C171.161 46.4818 171.516 46.1267 171.516 45.6886C171.516 45.2506 171.161 44.8955 170.724 44.8955C170.286 44.8955 169.931 45.2506 169.931 45.6886C169.931 46.1267 170.286 46.4818 170.724 46.4818Z"
        fill="#EAEEF9"
      />
      <path
        d="M149.674 50.7709C149.962 50.7709 150.195 50.5373 150.195 50.2491C150.195 49.9609 149.962 49.7273 149.674 49.7273C149.386 49.7273 149.153 49.9609 149.153 50.2491C149.153 50.5373 149.386 50.7709 149.674 50.7709Z"
        fill="#EAEEF9"
      />
      <path
        d="M152.071 60.1517C152.359 60.1517 152.592 59.9181 152.592 59.6299C152.592 59.3418 152.359 59.1082 152.071 59.1082C151.783 59.1082 151.549 59.3418 151.549 59.6299C151.549 59.9181 151.783 60.1517 152.071 60.1517Z"
        fill="#EAEEF9"
      />
      <path
        d="M154.857 60.1517L162.173 57.8594V48.4609L154.857 50.7356V60.1517Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M169.489 60.1517L162.173 57.8594V48.4609L169.489 50.7356V60.1517Z"
        fill="#6D7C9A"
      />
      <path
        d="M154.857 60.1517L162.173 57.8594V48.4609L154.857 50.7356V60.1517Z"
        fill="url(#paint17_linear_297_57359)"
      />
      <path
        d="M169.489 60.1517L162.173 57.8594V48.4609L169.489 50.7356V60.1517Z"
        fill="url(#paint18_linear_297_57359)"
      />
      <path
        d="M162.173 62.4616L154.857 60.1692V50.7708L162.173 53.0631V62.4616Z"
        fill="#EDF1F9"
      />
      <path
        d="M162.173 62.4616L169.489 60.1692V50.7708L162.173 53.0631V62.4616Z"
        fill="#DAE1ED"
      />
      <path
        opacity="0.09"
        d="M160.516 60.804L154.857 60.1692V50.7708L162.173 53.0631L160.516 60.804Z"
        fill="url(#paint19_linear_297_57359)"
      />
      <path
        opacity="0.2"
        d="M163.83 59.1465L169.489 60.1692V50.7708L162.173 53.0631L163.83 59.1465Z"
        fill="url(#paint20_linear_297_57359)"
      />
      <path
        d="M162.173 48.4609L158.733 45.8865L151.295 48.3904L154.857 50.7356L162.173 48.4609Z"
        fill="#DAE1ED"
      />
      <path
        d="M162.173 48.4609L165.612 45.8865L173.05 48.3904L169.489 50.7356L162.173 48.4609Z"
        fill="#DAE1ED"
      />
      <path
        d="M154.857 50.7708L162.173 53.0631L158.524 55.3907L151.295 52.9925L154.857 50.7708Z"
        fill="#EFF4FD"
      />
      <path
        d="M169.489 50.7708L162.173 53.0631L165.822 55.3907L173.05 52.9925L169.489 50.7708Z"
        fill="#EDF1F9"
      />
      <path
        d="M164.214 39.438C165.239 42.2195 165.545 42.8375 165.645 45.5782C165.606 46.2038 165.582 46.884 165.287 47.4318C164.894 48.2698 163.93 48.8501 163.02 48.8595C162.082 48.8763 161.163 48.3021 160.749 47.4168C160.458 46.8795 160.467 46.1445 160.866 45.6567C161.301 45.1888 162.064 45.0722 162.614 45.3645C163.218 45.6421 163.579 46.2194 163.712 46.8282C163.846 47.437 163.787 48.0973 163.624 48.6977C163.283 50.1578 163.001 50.2285 162.164 52.7006"
        stroke="#ABB5CC"
        strokeWidth="0.41438"
        strokeMiterlimit="10"
        strokeDasharray="0.83 0.83"
      />
      <path
        d="M165.461 37.9658C165.459 38.3747 165.078 38.6252 164.596 38.4946C164.087 38.408 163.728 38.3187 163.705 37.9536C163.716 37.5793 164.125 37.4328 164.603 37.2676C165.176 37.0399 165.429 37.5661 165.461 37.9658Z"
        fill="#DAE2EB"
      />
      <path
        d="M162.178 39.2164C162.435 39.4815 162.978 39.5588 163.243 39.1538C163.533 38.7049 163.781 38.3785 163.514 38.0787C163.257 37.8136 163.006 37.9921 162.433 38.2199C161.973 38.4543 161.876 38.9259 162.178 39.2164Z"
        fill="#DAE2EB"
      />
      <path
        d="M163.366 37.5248C163.6 37.4249 163.881 37.4982 164.006 37.6873C164.06 37.7473 164.122 37.8419 164.141 37.9112C164.34 38.3775 164.278 38.8397 164.008 38.949C163.714 39.1021 163.308 38.8397 163.152 38.3987C163.115 38.2601 163.097 38.1909 163.069 38.0869C163.039 37.8352 163.132 37.6247 163.366 37.5248C163.401 37.5155 163.366 37.5248 163.366 37.5248Z"
        fill="#989FB0"
      />
      <path
        d="M152.592 45.0307H152.138V44.5769H151.749V45.0307H151.295V45.4326H151.749V45.8863H152.138V45.4326H152.592V45.0307Z"
        fill="url(#paint21_linear_297_57359)"
      />
      <path
        d="M153.588 56.4152H153.135V55.9614H152.746V56.4152H152.292V56.8171H152.746V57.2708H153.135V56.8171H153.588V56.4152Z"
        fill="url(#paint22_linear_297_57359)"
      />
      <path
        d="M173.425 56.441L172.869 56.1607L173.15 55.6055L172.674 55.3653L172.394 55.9204L171.838 55.6401L171.59 56.1319L172.145 56.4122L171.865 56.9673L172.341 57.2076L172.621 56.6524L173.176 56.9327L173.425 56.441Z"
        fill="url(#paint23_linear_297_57359)"
      />
      <path
        d="M171.544 134.822L139.587 102.891L146.913 95.5647L178.844 127.521L171.544 134.822Z"
        fill="#858B9B"
      />
      <path
        d="M187.459 150.862L162.955 126.358C160.909 124.312 160.909 120.978 162.955 118.931C165.001 116.885 168.336 116.885 170.382 118.931L194.886 143.435C196.932 145.482 196.932 148.816 194.886 150.862C192.84 152.909 189.505 152.909 187.459 150.862Z"
        fill="#858B9B"
      />
      <path
        d="M185.716 152.429L154.19 120.902C153.457 120.17 153.457 118.982 154.19 118.224L162.248 110.166C162.981 109.433 164.168 109.433 164.926 110.166L196.453 141.693C197.185 142.425 197.185 143.613 196.453 144.371L188.394 152.429C187.636 153.162 186.449 153.162 185.716 152.429Z"
        fill="url(#paint24_linear_297_57359)"
      />
      <path
        d="M103.412 0C69.9657 0 42.8599 27.1058 42.8599 60.5523C42.8599 93.9736 69.9657 121.105 103.387 121.105C136.833 121.105 163.939 93.9988 163.939 60.5523C163.939 27.1058 136.833 0 103.412 0ZM103.412 109.888C76.559 109.888 54.8087 87.7845 54.8087 60.5271C54.8087 33.2697 76.559 11.1909 103.412 11.1909C130.265 11.1909 152.016 33.2949 152.016 60.5523C152.016 87.8097 130.24 109.888 103.412 109.888Z"
        fill="url(#paint25_linear_297_57359)"
      />
      <defs>
        <filter
          id="filter0_d_297_57359"
          x="50.3179"
          y="10.1953"
          width="106.494"
          height="124.986"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12.2622" />
          <feGaussianBlur stdDeviation="12.2622" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_297_57359"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_297_57359"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_297_57359"
          x="0.475086"
          y="21.9419"
          width="88.7354"
          height="101.493"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12.2622" />
          <feGaussianBlur stdDeviation="12.2622" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_297_57359"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_297_57359"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_297_57359"
          x="117.16"
          y="21.9419"
          width="88.7354"
          height="101.493"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12.2622" />
          <feGaussianBlur stdDeviation="12.2622" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_297_57359"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_297_57359"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_297_57359"
          x1="103.546"
          y1="20.701"
          x2="103.546"
          y2="99.2129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_297_57359"
          x1="100.739"
          y1="42.953"
          x2="99.2255"
          y2="49.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_297_57359"
          x1="100.739"
          y1="42.953"
          x2="99.2255"
          y2="49.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_297_57359"
          x1="95.6344"
          y1="55.1769"
          x2="98.2993"
          y2="47.6501"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_297_57359"
          x1="110.227"
          y1="57.2329"
          x2="110.436"
          y2="47.6815"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_297_57359"
          x1="88.7296"
          y1="36.1007"
          x2="88.7296"
          y2="37.2151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_297_57359"
          x1="90.2409"
          y1="53.3632"
          x2="90.2409"
          y2="54.4776"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_297_57359"
          x1="120.481"
          y1="52.6567"
          x2="119.793"
          y2="54.0203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_297_57359"
          x1="44.8298"
          y1="32.991"
          x2="44.8298"
          y2="87.2133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_297_57359"
          x1="41.6987"
          y1="49.1416"
          x2="40.7008"
          y2="53.2957"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_297_57359"
          x1="41.6987"
          y1="49.1416"
          x2="40.7008"
          y2="53.2957"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_297_57359"
          x1="38.3325"
          y1="57.203"
          x2="40.09"
          y2="52.2391"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_297_57359"
          x1="47.956"
          y1="58.559"
          x2="48.0942"
          y2="52.2599"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_297_57359"
          x1="33.7787"
          y1="44.6224"
          x2="33.7787"
          y2="45.3573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_297_57359"
          x1="34.7753"
          y1="56.0069"
          x2="34.7753"
          y2="56.7419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_297_57359"
          x1="54.7187"
          y1="55.5411"
          x2="54.2647"
          y2="56.4403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_297_57359"
          x1="161.514"
          y1="32.991"
          x2="161.514"
          y2="87.2133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_297_57359"
          x1="159.864"
          y1="49.1416"
          x2="158.866"
          y2="53.2957"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_297_57359"
          x1="159.864"
          y1="49.1416"
          x2="158.866"
          y2="53.2957"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_297_57359"
          x1="156.498"
          y1="57.203"
          x2="158.255"
          y2="52.2391"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_297_57359"
          x1="166.121"
          y1="58.559"
          x2="166.259"
          y2="52.2599"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_297_57359"
          x1="151.944"
          y1="44.6224"
          x2="151.944"
          y2="45.3573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_297_57359"
          x1="152.94"
          y1="56.0069"
          x2="152.94"
          y2="56.7419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_297_57359"
          x1="172.884"
          y1="55.5411"
          x2="172.43"
          y2="56.4403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_297_57359"
          x1="153.62"
          y1="131.302"
          x2="197.01"
          y2="131.302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_297_57359"
          x1="42.8044"
          y1="60.5655"
          x2="163.961"
          y2="60.5655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
